module.exports = __webpack_public_path__ + "static/media/temperature-down.6a3d8ebc.svg";